export default "__VITE_ASSET__27a69ce6__"